// extracted by mini-css-extract-plugin
export var errorsContainer = "_uc-1";
export var link = "_uc-0";